export default {
  status: "狀態",
  stockStatus: "Stock Status",
  accessStatus: "Access Status",
  followUpStatus: "跟進狀態",
  editStatus: "編輯跟進狀態",
  createdAt: "創建日期",
  updatedAt: "最後更新",
  lastUpdatedAt: "最後更新",
  day: "天",
  hour: "小時",
  minute: "分鐘",
  safetyPoint: "安全記分",
  rewardPoint: "獎勵記分",
  Error: "Error",
  unKnowError: "發生未知錯誤，請稍後再試",
  nameEn: "名字 (英)",
  nameZh: "名字 (繁中)",
  nameZhCHS: "名字 (簡中)",
  descriptionEn: "描述 (英)",
  descriptionZh: "描述 (繁中)",
  descriptionZhCHS: "描述 (簡中)",
  remarks: "備註",
  remarkEn: "備註 (英)",
  remarkZh: "備註 (繁中)",
  remarkZhCHS: "備註 (簡中)",
  constructionSite: "工地",

  Popup: {
    created: "已新增紀錄",
    updated: "已更新紀錄",
    deleted: "已刪除紀錄",
    uploaded: "已上傳紀錄",
    imported: "已導入紀錄",
    generated: "已生成資料",
    sent: "已發出短訊",
    canceled: "預約已取消",
    confirmResent: "確認信訊已重新發出",
    terminated: "預約已終止",
    unsaved: "未儲存更改",
    leaveWithoutSaving: "不儲存並離開",
    confirmDelete: "確定刪除紀錄?",
    areYouSure: "是否確定？",
    lostDataWarning:
      "您將在沒有保存的情況下離開此頁面。\n所有變更都將丟失。\n您確定不保存就離開嗎？",
    bathUploadFailed: "第 {{number}} 個文件上傳失敗，請重試。",
    unKnow: "發生未知錯誤，請稍後再試",
    getResponseTimeout: "Request Timeout, Please try again later",
  },
  Button: {
    save: "儲存",
    update: "更新",
    close: "關閉",
    cancel: "取消",
    reset: "重置",
    search: "搜尋",
    delete: "刪除",
    confirm: "確認",
    add: "新增",
    back: "返回",
    refresh: "重新整理",
    redirect: "導向至網址",
    logout: "登出",
    downloadCSV: "下載CSV",
    download: "Download",
    generate: "Generate",
  },
  Status: {
    active: "有效",
    inactive: "無效",
    pending: "未處理",
    pendingApproval: "待審批",
    suspended: "未啟用",
    completed: "已完成",
    rejected: "已拒絕",
    approved: "已批准",
    updatedAt: "最後更新時間",
    submitted: "未處理",
    confirmed: "待領取",
    delivered: "已領取",
    cancelled: "已取消",
    paid: "已付款",
    unpaid: "未付款",
    inStock: "正常",
    lowStock: "少量庫存",
    outOfStock: "庫存不足",
    takenDown: "已下架",
    success: "成功",
    fail: "失敗",
    approve: "通過",
    reject: "否決",
    voided: "已作廢",
    pendingToVoid: "待作廢",
    processing: "處理中",
    cleared: "已抵消",
    failed: "Failed",
    error: "Error",
  },
  Menu: {
    Home: "主頁",
    Admins: "管理員",
    PointManagement: "分數管理",
    RiskReport: "風險報告",
    RiskManagement: "風險報告",
    UserGroup: "用戶群組",
    RewardsPoint: "積分獎勵",
    SafetyPoint: "安全記分",
    Users: "用戶管理",
    SystemOptions: "系統設定",
    Certificate: "證書審核",
    SiteAndZone: "工地和區域",
    Courses: "課程資料",
    UserDetail: "用戶資料",
    UserPoint: "用戶分數",
    ZonePoint: "區域分數",
    MyAccount: "個人檔案",
    Test: "Test",
    ContentUpdate: "Content Update",
    SafetyReason: "記分原因",
    SubContractor: "Company",
    TotalOf: "共有",
    NumberOfSearchResults: "項搜尋結果",
    Tags: "Tags",
    Report: "Reporting",
    TrainingReport: "訓練報告",
    PointMart: "Point Mart",
    StoreManagement: "Store Management",
    StoreManagementDetail: "Product List",
    ProductDetail: "Product",
    OrderManagement: "Order Management",
    OrderManagementDetail: "Order List",
    OrderDetail: "Order Detail",
    ProductCategory: "Product Category",
    SafetyPointManagement: "Safety Point Records",
    SafetyPointManagementDetail: "Safety Point Detail",
    RewardPointManagement: "Rewards Point Records",
    RewardPointManagementDetail: "Rewards Point Detail",
    ReportAndDownload: "Reporting & Download",
    BreachRecord: "Site Access Right",
    Company: "Client and Main-Con",
    Advertisement: "ADs Control",
    Configuration: "System Setting",
    ImportBatch: "Import Batch",
  },
  Auth: {
    welcome: "歡迎回來！",
    login: "登入",
    forgotPwd: "忘記密碼",
    tnc: "登錄即表示您同意我們的使用條款並接收電子郵件、更新並確認您已閱讀我們的隱私政策。",
  },
  Home: {
    welcome: "歡迎來到BuildSafe。",
  },
  Users: {
    id: "ID",
    name: "英文姓名",
    chineseName: "中文姓名",
    phone: "電話號碼",
    code: "編號",
    role: "職位",
    viewSafetyPoint: "查看記分",
    viewRewardPoint: "查看積分",
    displayCode: "展示QR code",
    qrCode: "用戶二維碼",
    basicInfo: "基本資料",
    hkid: "香港身份證號碼",
    workInfo: "工作資料",
    userId: "用戶ID",
    hkie: "香港工程師學會",
    hkicm: "香港營造師學會",
    cwrc: "建造業工人註冊證",
    cistc: "建造業安全訓練證明書 (綠卡)",
    hkis: "香港測量師學會",
    hkila: "香港園境師學會",
    hkia: "香港建築師學會",
    cistcAlt: "绿卡或其他同等证件",
    refNumber: "證件號碼",
    cardName: "姓名",
    memberShip: "Membership Class",
    dateOfCompletion: "完成課程日程",
    validFrom: "有效日期由",
    validTo: "有效日期至",
    expiryDate: "Expiry Date",
    dateOfIssue: "簽發日期",
    siteInfo: "所屬工地",
    expandAll: "展開全部",
    addZone: "新增工地",
    allZone: "全部工地",
    zone: "所屬工地",
    updatedAt: "最後更新時間",
    createdAt: "建立用戶時間",
    username: "登入郵箱",
    password: "密碼",
    confirmPassword: "確認密碼",
    changePassword: "更改密碼",
    currentPassword: "現有密碼",
    newPassword: "新密碼",
    authInfo: "登入資料",
    phoneChecking: "填入電話號碼",
    roleSelection: "選擇職位",
    infoSetting: "填入基本資料",
    position: "Position",
    dateOfBirth: "Date Of Birth",
    gender: "Gender",
    f: "Female",
    m: "Male",
    preferredLanguage: "Preferred Language",
    userNotFound: "User not found. User must send an otp in the app first.",
    userExist:
      "The user has already registered. Please enter the correct phone number.",
    selectCard: "請選擇你持有的證件",
    cardType: "Card Type",
    en: "English",
    zh: "繁體中文",
    zhCHS: "简体中文",
    phoneExist: "The phone number has already been registered.",
    SubContractor: "Company",
    Site: "Construction Site (For filter)",
    dateOfRegistration: "Date of Registration",
    serialNumber: "Serial Number (Back of the card)",
    permissionGroup: "Role (Permission User Group)",
    adminName: "Admin Name",
    companyName: "Client and Main-Con Name",
    companyType: "Company Type",
    roleUserGroup: "Role (User Group)",
    verifyUser: "Verify User",
    importAppUsers: "Bulk Registration",
    source: "Created By",
    app: "Mobile App",
    import: "Bulk Registration",
    cms: "CMS",
    system: "System",
  },
  RiskReport: {
    id: "報告ID",
    title: "標題",
    location: "發現地區",
    createdAt: "報告日期",
    reportInfo: "報告資料",
    status: "狀態",
    remarks: "跟進描述",
    description: "描述",
    reporter: "報告者",
    handler: "處理者",
    updatedAt: "最後更新",
    pointItem: "Point Item",
    point: "Point",
    approvedPointItem: "Approved Point Item",
  },
  Role: {
    unknown: "未知",
    cmsAdmin: "文書員工",
    siteAdmin: "地盤行政人員",
    manager: "管理人員",
    safetyAdmin: "安全人員",
    worker: "工友",
    frontline: "前線人員",
    external: "External",
    otherOfficeStaff: "其他文職職員",
    frontlineSupervisor: "前線管理人員",
  },
  Courses: {
    name: "Name",
    contentEn: "Content (Eng)",
    contentZh: "Content (Chi)",
    contentZhCHS: "Content (CHS)",
    credit: "Credit",
    offset: "No. of points offset",
    pointItemName: "Point Name",
    pointItemType: "Point Type",
    pointItemValue: "Point Value",
    course: "Course",
    training: "Additional Training Report",
    category: "Type",
    photo: "Photo",
    pointDeduction: "Point Related",
    pointItem: "Point Item",
    duration: "Duration",
    languageEn: "Language (Eng)",
    languageZh: "Language (Chi)",
    languageZhCHS: "Language (CHS)",
    url: "Website Url",
    priority: "Priority",
  },
  SafetyReason: {
    reason: "原因",
    point: "記分值",
    category: "類別",
    reasonEn: "Reason (Eng)",
    reasonZh: "Reason (Chi)",
    pointNumber: "No. of Point",
    value: "變動值",
    type: "類型",
    action: "操作",
    safetyPoint: "安全記分",
    rewardPoint: "獎勵積分",
    credit: "減值 (-)",
    debit: "加值 (+)",
    priority: "Priority",
  },
  Certificate: {
    title: "證書標題",
    user: "申請人",
    type: "證書類型",
    id: "證書ID",
    createdAt: "報告日期",
    phone: "電話",
    certificate: "證書",
    reporter: "報告者",
    description: "描述",
    reason: "審核描述",
    remarks: "跟進描述",
  },
  PointManagement: {
    User: "個人",
    Zone: "區域",
    name: "英文姓名",
    chineseName: "中文姓名",
    phone: "電話號碼",
    userId: "用戶ID",
    safetyPoint: "記分值",
    rewardPoint: "獎分值",
    FilterBySiteOrZone: "按工地或區域篩選",
    total: "全部",
    points: "分",
    inspectUserProfile: "查看用戶檔案",
    belongingConstructionSite: "所屬工地",
    createdAt: "建立日期",
    description: "描述",
    none: "無",
    good: "良好",
    slight: "輕微",
    moderate: "中等",
    severe: "嚴重",
    severity: "記分",
    credit: "記分",
    onlyLast12Months: "只記錄過去十二個月的記分",
    rewardPoints: "獎勵積分",
    totalPoints: "Points for All Sites",
    decisions: "Decisions",
    decidedBy: "Decided By",
    decidedAt: "Decided At",
    void: "Void",
    confirmToVoid: "Confirm to void this safety score?",
    addSafetyPoint: "Add Safety Score",
    safetyPointItem: "Offence in Operations",
    point: "Point",
    addRewardPoint: "Add Rewards Point",
    rewardPointItem: "Reason for Rewards",
  },
  SubContractor: {
    name: "Name",
    code: "Code",
  },
  Configuration: {
    en: "英文",
    zh: "中文",
    zhCHS: "簡體中文",
    page: "頁面",
    configuration: "Configuration",
    contentUpdate: "Content Update",
    tnc: "條款和條件",
    pp: "隱私政策",
    constructionSite: "Construction Site Configuration",
    defaultLogo: "Default Logo",
    breachRecord: "Site Access Right Configuration",
    gracePeriod: "Course Enrollment Grace Period",
    days: "Day(s)",
    gracePeriodReminder:
      "* Set to 0 days, the button of block will be appeared immediately.",
    advertisement: "ADs Control Configuration",
    displayDuration: "ADs Display Time",
    durationReminder:
      "* Set 0 seconds will enable the user to close the banner immediately.",
    seconds: "Second(s)",
    bulkRegistration: "Bulk Registration Configuration",
    tncLink: "T & C Link",
  },
  Validation: {
    required: "Required",
    invalidPhone: "Invalid Phone Number",
  },
  Report: {
    rewardPointTransaction: "Daily Rewards Point Download",
    safetyPointTransaction: "Daily Safety Point Download",
    from: "From",
    to: "To",
    user: "App User Download",
  },
  StoreManagement: {
    name: "Site Name",
    siteCode: "Site Code",
    point: "No. of Point Required",
    lowInStock: "Low Stocks Alert",
    availableStock: "Available Stock",
    reservedStock: "Reserved Stock",
    Medias: "Photos",
    availableFrom: "Valid From",
    availableTo: "Valid To",
    basic: "Basic Info",
    stock: "Stock Info",
    media: "Photos",
    SKUID: "Product Code",
    unitEn: "Unit (Eng)",
    unitZh: "Unit (Chi)",
    unitZhCHS: "Unit (CHS)",
    siteId: "Site ID",
    productId: "Product ID",
    totalStock: "Total Stock",
    remark: "Remark",
    store: "Store",
    changeAvailableStock: "Change Stock",
    add: "Add Stock (+)",
    reduce: "Reduce Stock (-)",
    type: "Type",
    expectedAvailableStock: "Expected Available Stock",
    unlimited: "Unlimited",
    productName: "Name",
    productCategory: "Product Category",
  },
  OrderManagement: {
    name: "Name",
    orderRef: "Order Reference Number",
    inspectUserProfile: "Go to Profile",
    displayOrderCode: "Display Order Code",
    basicInfo: "Basic Information",
    cartInfo: "Cart Information",
    productName: "Product Name",
    quantity: "Quantity",
    phoneNumber: "Phone Number",
    orderId: "Order ID",
    orderStatus: "Order Status",
    paidStatus: "Paid Status",
    user: "User",
    siteName: "Site Name",
    totalPoints: "Total Points",
    amount: "Amount",
    createdAt: "Created At",
    updatedAt: "Last Updated",
    remarks: "Remarks",
    redemptionPhoto: "Redemption Photo",
  },
  ProductCategory: {
    code: "Code",
  },
  UserGroup: {
    name: "Name",
    code: "Code",
    level: "Level",
    personal: "Personal",
    organization: "Organization",
    company: "Client and Main-Con",
    site: "Project Site",
    allGranted: "All Granted",
    read: "Read",
    create: "Create",
    update: "Update",
    delete: "Delete",
    inactiveReminder:
      "* Please ensure no users are assigned to this permission user group. ",
    selectedCompany: "Company",
  },
  ConstructionSite: {
    name: "Site Name",
    code: "Code",
    protocol: "Protocol",
    domain: "Domain",
    token: "Token",
    basicInfo: "Site Information",
    gateInfo: "Gate Information",
    eShopEnabled: "EShop Enabled",
    logo: "Logo",
    isJointVenture: "Joint Venture",
    zoneInfo: "Zones",
    zoneName: "Zone Name",
    zone: "Zone",
    gateContractor: "Gate Contractor",
    synergos: "Synergos",
    timeExpert: "Time Expert",
    cerebro: "Cerebro",
    gateContractorEnabled: "Gate Contractor Enabled",
    uploadReminder: "* Please upload photo dimensions within 600 x 220",
    supervisor: "Supervisor",
    companyInfo: "Client and Main-Con Information",
    mainConCompany: "Main Contractor",
    relatedMainConOwner: "Related Main Contractor Owner Companies",
    clientCompanies: "Clients",
    otherClientCompanies: "Clients",
    mainConCompanies: "Main Contractors",
    siteAccessRightEnabled:
      "Mobile App Site Access Right Enabled (For Site Admin)",
    removeMainConAccess: "Remove access right for Main Con",
    restoreMainConAccess: "Recover access right for Main Con",
    reminderMainConAccess:
      "Changing Main Con will prevent the Project CMS Admin from accessing the site.",
    confirmToRemoveMainConAccess:
      "Confirm to remove the access right for Main Con?",
    confirmToRestoreMainConAccess:
      "Confirm to recover access right for Main Con?",
    mainConAccessRightEnabled:
      "* No access right for Main Con. Please contact the super admin for further assistance.",
    mainConAccessStatus: "Main Con Access Status",
    removedBySite: "Removed by site",
    normal: "Normal",
    generateQrCode: "Registration QR Code",
    qrCode: "QR Code",
    removeMainConAccessReminder:
      "Removing access rights for the Main Con can no longer update the Main Con info. If you need to update the Main Con info, please contact the 'System Admin' to recover access rights.",
    canSkipPointTransactionApproval:
      "Skip Approval for Safety & Rewards Points",
  },
  BreachRecord: {
    totalPoints: "Safety Points",
    lastUpdatedBy: "Last Updated By",
    updatedBy: "Updated By",
    uploadedCert: "Uploaded Certificates",
    status: "Status",
    createdAt: "Date Reached 15 Points",
    remarks: "Remarks",
    courseDate: "Reserved Attending Date",
    title: "Title",
    description: "Description",
    actionLog: "Action Logs",
    action: "Action",
    lastRefresh: "Last refresh date",
    changeStatus: "Change Status",
    cancelEnrolment: "Cancel Enrolment",
    uploadCertificate: "Upload Certificate",
    rejectCertificate: "Reject Certificate",
    approveCertificate: "Approve Certificate",
    uploadEnrolmentProof: "Upload Enrolment Proof",
    balanceBelowThreshold: "Below 15 Points",
    balanceAboveThreshold: "Reached 15 Points",
    blockUser: "Block User",
    unblockUser: "Unblock User",
    enrolmentInfo: "Improvement Course Details",
    statusInfo: "Status Info",
    Photo: "Photo",
    cwrc: "CWRC Number",
    gateBlockUser: "Block User by Gate",
    gateUnblockUser: "Unblock User by Gate",
    blockRemarks: "Block Remarks",
    blockedDate: "Blocked Date",
    pendingForEnrolment: "待報讀課程",
    pendingForUploadCertificate: "待上傳證書",
    pendingForCertificateApproval: "待證書審批",
    certificateApproved: "證書已審批",
    cleared: "自動清除",
    manuallyCleared: "手動清除",
    blocked: "已禁止",
    unblocked: "可通行",
    blockedByGate: "由閘機系統禁止",
  },
  Company: {
    id: "ID",
    type: "Company Type",
    name: "Name",
    code: "Code",
    client: "Client",
    mainContractorOwner: "Main Contractor Owner",
    mainContractor: "Main Contractor",
    layer2: "Client",
    layer3: "Main Contractor",
    searchType: "Search Company Type",
    mainConOwnerCompanies: "Main Contractor Owner Companies",
  },
  Advertisement: {
    Image: "Image",
    priority: "Priority",
    validFrom: "Valid From",
    validTo: "Valid To",
    visibleTo: "User Types for Viewing Ads",
    url: "Links",
    name: "Name",
    uploadReminder: "* Support JPG and PNG",
  },
  ImportBatch: {
    uploadAppUsers: "Upload App Users",
    template: "Template",
    downloadTemplate: "Generate Excel",
    uploadExcel: "Upload Excel",
    previewUploadedFile: "Preview Uploaded File",
    importUploadedFile: "Confirm Import User",
    row: "Row",
    rawData: "Raw Data",
    errorMessage: "Error Message",
    confirmImportHeader: "Confirm to Add User",
    confirmToImport1:
      "Please check and confirm if the inputted information is correct. Please let users acknowledge and confirm ",
    confirmToImport2: " before creating their account.",
    history: "Bulk Registration History",
    previewResults: "Preview Results",
    importResults: "Import Results",
    total: "Total",
    items: "item(s)",
    previewStatus: {
      completed: "Passed",
      failed: "Incomplete",
      pending: "Pending",
    },
    importStatus: {
      completed: "Completed",
      failed: "Failed",
      pending: "Pending",
    },
  },
};
